<template>
	<section>
		<header-page
			name="sidebar"
			:title="$route.meta.title"
		/>
		<general-filter class="mt-4">
			<v-flex xs12 sm3 pr-3>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					:items="companies"
					item-text="nombreComercial"
					item-value="codeCompany"
					label="Compañías"
					v-model="codeCompany"
					@input="loadRoles"
				></v-select>
			</v-flex>
			<v-flex xs12 sm3 pr-3>
				<v-select
					background-color="white"
					box
					class="body-1"
					hide-details
					:disabled="!codeCompany"
					:items="roles"
					item-text="name"
					item-value="id"
					label="Roles"
					v-model="roleId"
					@input="loadSidebar"
				></v-select>
			</v-flex>
		</general-filter>
	</section>
</template>

<script>
	function created() {
		this.loadCompanies();
	}

	async function loadCompanies() {
		const { data: companies } = await this.$http.get(`project/${this.codeProject}/companies`);
		this.companies = companies.data;
		this.codeCompany = companies.data[0].codeCompany;
		this.loadRoles();
	}

	async function loadRoles() {
		const { data: roles } = await this.$http.get(`company/${this.codeCompany}/project/${this.codeProject}/role`);
		this.roles = roles.data;
	}

	function loadSidebar() {}

	function data() {
		return {
			codeCompany: '',
			companies: [],
			roleId: 0,
			roles: [],
		};
	}

	export default {
		name: 'page-sidebar',
		created,
		data,
		methods: {
			loadCompanies,
			loadRoles,
			loadSidebar,
		},
		props: {
			codeApp: {
				type: String,
			},
			codeProject: {
				type: String,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/sidebar/page-sidebar.vue